package com.iptvplayer.shared.domain.model

import kotlinx.serialization.Serializable

@Serializable
data class Favorite(
    val id: String,
    val userId: String,
    val contentId: String,
    val contentType: ContentType,
    val contentName: String,
    val contentLogoUrl: String? = null,
    val streamUrl: String,
    val addedAt: Long
)

@Serializable
enum class ContentType {
    CHANNEL,
    VOD
}
